<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">Petty account</small>
      </legend>
      <div>
        <form @submit.prevent="newPayments()">
          <div class="form-group">
            <label>Petty account name</label>
            <input
              type="text"
              class="form-control pettyaccounts_name input-rounded f-s-14"
              placeholder="petty account name"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingPettyaccount btn-rounded">
            <i class="fa fa-plus"></i> create Account
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingPettyaccountLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["newPayments"])
  }
};
</script>
<style scoped>
.creatingPettyaccountLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/pettyaccounts/pettyaccount.vue